import { useMemo } from 'react';
import {
  GENDER_CATEGORIES,
  SIZES_CATEGORIES,
  WEIGHT_CATEGORIES,
} from '@/config/category-fields.config';

export interface CategoryRequirements {
  showGender: boolean;
  showSizes: boolean;
  showWeight: boolean;
}

/**
 * Hook pour déterminer quels champs additionnels afficher
 * selon la catégorie de produit sélectionnée.
 *
 * @param categoryName - Le nom de la catégorie sélectionnée
 * @returns Un objet indiquant quels champs doivent être affichés
 */
export function useCategoryRequirements(
  categoryName: string | undefined
): CategoryRequirements {
  return useMemo(
    () => ({
      showGender: categoryName
        ? (GENDER_CATEGORIES as readonly string[]).includes(categoryName)
        : false,
      showSizes: categoryName
        ? (SIZES_CATEGORIES as readonly string[]).includes(categoryName)
        : false,
      showWeight: categoryName
        ? (WEIGHT_CATEGORIES as readonly string[]).includes(categoryName)
        : false,
    }),
    [categoryName]
  );
}
